<!--
 * @Author: ZhaoG
 * @Date: 2025-04-10 18:34:16
 * @LastEditors: ZhaoG
 * @LastEditTime: 2026-03-10 11:09:50
 * @FilePath: \sra-fe\src\views\register\material\maPerfectInfo\qualificationDocuments.vue
 * @Description:资质文件
-->
<template>
  <div>
    <div class="sign-content">
      <el-card-title :title="title" />
      <div :class="isChinese === 'zh-cn'?'danger-title':'danger-title-en'">{{$t('page.qualificationFile.contentTitles.hintMsg1')}}<span class="span-num">{{$t('page.qualificationFile.contentTitles.hintMsg2')}}</span>{{$t('page.qualificationFile.contentTitles.hintMsg3')}}<span class="span-num">{{$t('page.qualificationFile.contentTitles.hintMsg4')}}</span></div>
      <div class="contract-title-from">
        <el-table
          :data="tableData"
          border
          style="width: 100%">
          <el-table-column
            prop="name"
            showOverflowTooltip
            :label="$t('page.qualificationFile.tableTh.name')"
            :width="isChinese === 'zh-cn'?'160':'230'">      <!-- 名称 -->
            <template slot-scope="scope">
              {{ scope.row.name }}
              <span v-if="(scope.row.id === '00' && isChinese === 'zh-cn') || (scope.row.id === '01' && isChinese === 'zh-cn')" style="color: #ff0000"
              >*</span>
              <span v-if="scope.row.id === '30' && isChinese === 'zh-cn' && supType.includes('9')" style="color: #ff0000">*</span>
              <!-- <span v-if="scope.row.id === '02' && isChinese === 'zh-cn'" style="color: #ff0000"
              >{{$t('page.qualificationFile.tableTd.taxationImg2')}}*</span> -->
            </template>
          </el-table-column>
          <el-table-column
            prop="type"
            :label="$t('page.qualificationFile.tableTh.type')"
            :width="isChinese === 'zh-cn'?'50':'50'">      <!-- 类型 -->
          </el-table-column>
          <el-table-column
            prop="fileName"
            :label="$t('page.qualificationFile.tableTh.file')"
            width="120">      <!-- 文件 -->
          </el-table-column>
          <el-table-column
            :label="$t('page.qualificationFile.tableTh.enclosureNotation')"
            :width="isChinese === 'zh-cn'?'160':'190'">      <!-- 附件说明 -->
            <template slot-scope="scope">
              <el-input :placeholder="$t('page.qualificationFile.tableTh.input')" v-model="scope.row.fileDesc" show-word-limit  maxlength="50"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('page.qualificationFile.tableTh.operation')"
            :width="isChinese === 'zh-cn'?'80':'80'"
            class="operation">     <!-- 操作 -->
            <template slot-scope="scope">
              <el-upload
                :show-file-list="false"
                :action="uploadUrl"
                class="upload-demo tow"
                :on-progress="onProgress"
                :before-upload="beforeAvatarUpload"
                :on-success="onSuccess"
                :on-error="onError"
              >
                <el-button type="text" @click="getIndex(scope.$index,scope.row.id)">{{$t('page.qualificationFile.btn.uploading')}}</el-button>      <!-- 上传 -->
              </el-upload>
              <el-button
                style="color:#0089EF;cursor:pointer"
                type="text"
                @click="deleteAppend(scope.row)"
                class="removeBtn"
              >{{$t('page.qualificationFile.btn.del')}}</el-button
              >         <!-- 删除 -->
            </template>
          </el-table-column>
        </el-table>
<!--   180 30 160 180 80 zh-CN     -->
      </div>
    </div>
    <div class="btnBox">
      <el-button
        class="left-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="back()"
      >
        <span>{{ $t('basicLayout.btn')[0] }}</span>
      </el-button>
      <el-button
        class="right-btn btn"
        size="mini"
        type="primary-icon-medium"
        @click="submit"
        :disabled="isSub"
      >
        <span>{{ $t('basicLayout.btn')[2] }}</span>
      </el-button>
    </div>
    <!-- 提交弹层 -->
    <el-dialog
      :title="$t('page.productInfo.dialog.info')"
      :visible.sync="dialogVisible1"
      width="600px"
    >
      <span>{{$t('page.qualificationFile.info.dialog1')}}</span>
      <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="default-mini" @click="dialogVisible1 = false">{{$t('page.productInfo.btn.cancel')}}</el-button>
      <el-button size="mini" type="primary-font-mini" @click="confirmNext">{{$t('page.productInfo.btn.confirm')}}</el-button>
    </span>
    </el-dialog>
    <!-- 提交完成以后的提示信息 -->
    <el-dialog
      :title="$t('page.productInfo.dialog.info')"
      :visible.sync="dialogVisible2"
      @close="confirmSubmit"
      width="600px"
    >
      <span v-if="languagezh_cn">{{$t('page.qualificationFile.info.dialog2')+recommendIndyName+'（'+orgFullName+'）'+'审核。请注意留存账号、密码等重要信息（账号信息已同步发至联系人邮箱）'}}</span>
      <span v-else>{{$t('page.qualificationFile.info.dialog2')}}</span>
      <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary-font-mini" @click="confirmSubmit">{{$t('page.productInfo.btn.confirm')}}</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import {qrySupRegistAccountInfo,saveSupplierRegistInfo,qrySupRegistQualificationFileList} from '@/api/supRegister'
import {mapActions} from 'vuex'
  import {uploadFileToOss} from '@/api/supRegister'
import Setting from "@/config/index";
import Cookies from "js-cookie";
import { Loading } from "ccui";
const savedLocaleKey = Setting.i18n.cookieLable;
export default {
  name: "qualificationDocuments",
  data() {
    let baseUrl = this.$addUrlPerFix(process.env.VUE_APP_BASE_URL);
    return {
      index: 0,
      isCredentials:"0",
      uploadLoading: null,
      recommendIndyName:"",
      orgFullName:'',
      rowId: '',
      title: window.$t('page.qualificationFile.contentTitle.qualificationFile'),      // 资质文件信息
      tableData: [
        {
          id: '00',
          name: window.$t('page.qualificationFile.tableTd.businessLicense'),    // 营业执照副本图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '01',
          name: window.$t('page.qualificationFile.tableTd.identityCard'),     // 法人代表身份证复印件
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '03',
          name: window.$t('page.qualificationFile.tableTd.frameworkImg'),      // 组织机构代码证图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '02',
          name: window.$t('page.qualificationFile.tableTd.taxationImg'),      // 税务登记证图片(含增值税一般纳税人红章页面)
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '04',
          name: window.$t('page.qualificationFile.tableTd.qualityControl'),      // 质量管理体系认证证书
          type: window.$t('page.qualificationFile.tableTd.img'),      //  图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '10',
          name: window.$t('page.qualificationFile.tableTd.specialIndustry'),      //  特殊行业资质证书图片
          type: window.$t('page.qualificationFile.tableTd.file'),       // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '05',
          name: window.$t('page.qualificationFile.tableTd.organizationChart'),      // 组织架构及营销网络相关文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '06',
          name: window.$t('page.qualificationFile.tableTd.companyQualification'),      // 公司资质及荣誉文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '07',
          name: window.$t('page.qualificationFile.tableTd.productionLicence'),      // 生产许可证图片
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },{
          id: '11',
          name: window.$t('page.qualificationFile.tableTd.distributiontImg'),      // 经销代理资格证明图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },{
          id: '08',
          name: window.$t('page.qualificationFile.tableTd.financialStatement'),      // 财务报表(上年度经审计的财务报表)
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '09',
          name: window.$t('page.qualificationFile.tableTd.cooperationFile'),       // 合作业绩证明文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '13',
          name: window.$t('page.qualificationFile.tableTd.environmentalManagement'),      // 环境管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },{
          id: '12',
          name: window.$t('page.qualificationFile.tableTd.healthySafety'),      // 健康安全管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '30',
          name: window.$t('page.qualificationFile.tableTd.transportation'),      // 运输许可证
          type: window.$t('page.qualificationFile.tableTd.file'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '99',
          name: window.$t('page.qualificationFile.tableTd.otherFiles'),       // 其他文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
      ],
      uploadUrl: baseUrl + "/apis/sra/oss/users/signup/uploadFilePersNew", //上传图片
      SupRegistQualFileInfoBO: [],
      dialogVisible1: false,
      dialogVisible2: false,
      supInfoApplyId: '',
      isChinese: Cookies.get(savedLocaleKey) || 'zh-cn',
      isSub: false,
      supType: []
    }
  },
  created() {
    if(Cookies.get('access_token') || this.$route.query.tempSupinfoId) {
      this.getSupRegistQualificationFileList()
      this.qrySupRegistAccountInfo()
    }
    if(Cookies.get(savedLocaleKey) === 'zh-cn') {
      this.tableData = [
        {
          id: '00',
          name: window.$t('page.qualificationFile.tableTd.businessLicense'),    // 营业执照副本图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '01',
          name: window.$t('page.qualificationFile.tableTd.identityCard'),     // 法人代表身份证复印件
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '03',
          name: window.$t('page.qualificationFile.tableTd.frameworkImg'),      // 组织机构代码证图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '02',
          name: window.$t('page.qualificationFile.tableTd.taxationImg'),      // 税务登记证图片(含增值税一般纳税人红章页面)
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '04',
          name: window.$t('page.qualificationFile.tableTd.qualityControl'),      // 质量管理体系认证证书
          type: window.$t('page.qualificationFile.tableTd.img'),      //  图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '10',
          name: window.$t('page.qualificationFile.tableTd.specialIndustry'),      //  特殊行业资质证书图片
          type: window.$t('page.qualificationFile.tableTd.file'),       // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '05',
          name: window.$t('page.qualificationFile.tableTd.organizationChart'),      // 组织架构及营销网络相关文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '06',
          name: window.$t('page.qualificationFile.tableTd.companyQualification'),      // 公司资质及荣誉文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '07',
          name: window.$t('page.qualificationFile.tableTd.productionLicence'),      // 生产许可证图片
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },{
          id: '11',
          name: window.$t('page.qualificationFile.tableTd.distributiontImg'),      // 经销代理资格证明图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '08',
          name: window.$t('page.qualificationFile.tableTd.financialStatement'),      // 财务报表(上年度经审计的财务报表)
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '09',
          name: window.$t('page.qualificationFile.tableTd.cooperationFile'),       // 合作业绩证明文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '13',
          name: window.$t('page.qualificationFile.tableTd.environmentalManagement'),      // 环境管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },{
          id: '12',
          name: window.$t('page.qualificationFile.tableTd.healthySafety'),      // 健康安全管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '30',
          name: window.$t('page.qualificationFile.tableTd.transportation'),      // 运输许可证
          type: window.$t('page.qualificationFile.tableTd.file'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '99',
          name: window.$t('page.qualificationFile.tableTd.otherFiles'),       // 其他文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
      ]
    } else {
      this.tableData = [
        {
          id: '00',
          name: window.$t('page.qualificationFile.tableTd.businessLicense'),    // 营业执照副本图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '01',
          name: window.$t('page.qualificationFile.tableTd.identityCard'),     // 法人代表身份证复印件
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '02',
          name: window.$t('page.qualificationFile.tableTd.taxationImg'),      // 税务登记证图片(含增值税一般纳税人红章页面)
          type: window.$t('page.qualificationFile.tableTd.img'),     // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '04',
          name: window.$t('page.qualificationFile.tableTd.qualityControl'),      // 质量管理体系认证证书
          type: window.$t('page.qualificationFile.tableTd.img'),      //  图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '10',
          name: window.$t('page.qualificationFile.tableTd.specialIndustry'),      //  特殊行业资质证书图片
          type: window.$t('page.qualificationFile.tableTd.file'),       // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '06',
          name: window.$t('page.qualificationFile.tableTd.companyQualification'),      // 公司资质及荣誉文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '07',
          name: window.$t('page.qualificationFile.tableTd.productionLicence'),      // 生产许可证图片
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },{
          id: '11',
          name: window.$t('page.qualificationFile.tableTd.distributiontImg'),      // 经销代理资格证明图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        // {
        //   id: '08',
        //   name: window.$t('page.qualificationFile.tableTd.financialStatement'),      // 财务报表(上年度经审计的财务报表)
        //   type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
        //   fileDesc: '',
        //   fileName: ''
        // },
        {
          id: "15",
          name: window.$t(
            "page.qualificationFile.tableTd.businessLicenses"
          ), // 经营许可证
          type: window.$t("page.qualificationFile.tableTd.img"), // 文件
          fileName: "",
          fileDesc: "",
          uploadId: ""
        },
        {
          id: '21',
          name: window.$t('page.qualificationFile.tableTd.cooperationFile'),       // 海关注册码
          type: window.$t('page.qualificationFile.tableTd.img'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '13',
          name: window.$t('page.qualificationFile.tableTd.environmentalManagement'),      // 环境管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },{
          id: '12',
          name: window.$t('page.qualificationFile.tableTd.healthySafety'),      // 健康安全管理体系认证证书图片
          type: window.$t('page.qualificationFile.tableTd.img'),      // 图片
          fileDesc: '',
          fileName: ''
        },
        {
          id: '30',
          name: window.$t('page.qualificationFile.tableTd.transportation'),      // 运输许可证
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
        {
          id: '99',
          name: window.$t('page.qualificationFile.tableTd.otherFiles'),       // 其他文件
          type: window.$t('page.qualificationFile.tableTd.file'),      // 文件
          fileDesc: '',
          fileName: ''
        },
      ]
    }
    if(this.$route.path === '/maPerfectInfo/qualificationDocuments'){
      this.changeCheckPage(10)
     for(let i = 0; i < 6; i++){
        this.msgCenter.$emit('ballMoveRight')
      }
    }
    // 获取供应商类型

  },
  methods: {
    ...mapActions(["changeCheckPage"]),
    back() {
      this.changeCheckPage(9)
      this.$emit('back')
      // if(this.isChinese === 'zh-cn') {
        this.$router.push({path:'/maPerfectInfo/greenLowCarbon',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
      // } else {
      //   this.$router.push({path:'/maPerfectInfo/financialInformation',query:{tempSupinfoId: this.$route.query.tempSupinfoId}})
      // }
    },
    onProgress(progressEvent) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      if (progressEvent.percent > 90) {
        progressEvent.percent = 98;
      }
      console.log("progressEvent", progressEvent);
    },
    onSuccess(res) {
      console.log(res)
      this.uploadLoading.close();
      if(res.code === '0') {
        this.$message.success(window.$t('page.qualificationFile.info.upload1'))
      }
      let fileData = res.data[0];
      this.$set(this.tableData[this.index], "fileName", fileData.fileName);
      this.$set(this.tableData[this.index], "fileSize", fileData.fileSize);
      this.$set(this.tableData[this.index], "fileUrl", fileData.downloadUrl);
      this.$set(this.tableData[this.index], "uploadTime", fileData.updateTime);
      this.$set(this.tableData[this.index], "uploadId", fileData.uploadId);
    },
    onError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading.close();
    },
    beforeAvatarUpload(file) {
      this.uploadLoading = Loading.service({
        lock: true,
        text: "上传中,请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.2)",
        customClass: "ccui-custom-loading"
      });
      console.log(file);
      const sub = this.tableData.some(item => {
        if(file.name === item.fileName&&(!this.isCredentials||this.isCredentials==0)) {
          return true
        }
      })
      if(!sub) {
        let isUpload = true;
        let fileTypeLen = file.name.split(".")
        let imgType = ["jpg", "jpeg", "png", "gif", "webp"]
        let fileType = ["xls", "xlsx", "doc", "docx","pdf"]
        const isLt400k = file.size / 1024 / 1024 < 15;//15M
        const isLt4M = file.size / 1024 / 1024 < 30;//30M以内
        if(this.tableData[this.index].type === '图片'||this.tableData[this.index].type ==='Picture') {
          let isImg = imgType.includes(
            fileTypeLen[fileTypeLen.length - 1].toLowerCase()
          );
          console.log(isImg)
          if(!isImg) {
            this.uploadLoading.close();
            this.$message({
              type: "error",
              message: window.$t('page.qualificationFile.info.uploadErr1'),
              offset: document.body.clientHeight / 2 - 21,
            });
            isUpload = false
          } else if (!isLt400k){
            this.uploadLoading.close();
            this.$message({
              type: "error",
              message: window.$t('page.qualificationFile.info.uploadErr2'),
              offset: document.body.clientHeight / 2 - 21,
            });
            isUpload = false;
          }
        } else if (this.tableData[this.index].type === '文件') {
          let isFile = fileType.includes(
            fileTypeLen[fileTypeLen.length - 1].toLowerCase()
          );
          console.log(isFile)
          if(!isFile) {
            this.uploadLoading.close();
            this.$message({
              type: "error",
              message: window.$t('page.qualificationFile.info.uploadErr3'),
              offset: document.body.clientHeight / 2 - 21,
            });
            isUpload = false
          } else if (!isLt4M){
            this.uploadLoading.close();
            this.$message({
              type: "error",
              message: window.$t('page.qualificationFile.info.uploadErr4'),
              offset: document.body.clientHeight / 2 - 21,
            });
            isUpload = false;
          }
        }
        return isUpload
      } else {
        this.uploadLoading.close();
        this.$message.error(window.$t('page.qualificationFile.info.sameFile'))
        return false
      }
    },
    deleteAppend(row) {
      if(row.fileName === '') {
        this.$message.error(window.$t('page.qualificationFile.info.delErr'))
      } else {
        this.$confirm(`${window.$t('page.productInfo.delInfo.delInfo')}`, `${window.$t('page.productInfo.dialog.info')}`, {
          confirmButtonText: window.$t('page.productInfo.btn.confirm'),
          cancelButtonText: window.$t('page.productInfo.btn.cancel'),
          type: 'warning',
        }).then(() => {
          row.fileName = ''
          this.$message({
            type: 'success',
            message: window.$t('page.productInfo.delInfo.confirmDel')  // 删除成功
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: window.$t('page.productInfo.delInfo.cancelInfo')  // 已取消删除
          });
        });
      }
    },
    getIndex(index,id) {
      this.index = index;
      this.rowId = id
    },
    // 提交数据
    submit() {
      if(this.isChinese === 'zh-cn') {
        const sub =  this.tableData.some((item,index) => {
          if(this.isCredentials==0||!this.isCredentials){
            this.tableData.some((i,j)=>{
              if(j!=index && item.fileName&&item.fileName==i.fileName){
                this.$message.error(window.$t('page.qualificationFile.info.sameFile'))
                throw Error()
              }
            })
          }
          if(item.id === '00' && item.fileName === '') {
            this.$message.error(window.$t('page.qualificationFile.info.subErr1'))
            return true
          } else if (item.id === '01' && item.fileName === '') {
            this.$message.error(window.$t('page.qualificationFile.info.subErr5'))
            return true
          }
          // else if (item.id === '03' && item.fileName === '') {
          //   this.$message.error(window.$t('page.qualificationFile.info.subErr2'))
          //   return true
          // } else if (item.id === '02' && item.fileName === '') {
          //   this.$message.error(window.$t('page.qualificationFile.info.subErr3'))
          //   return true
          // }
          else if (item.id === '30' && item.fileName ==='' && this.supType.includes('9')) { // 承运商运输许可证必填
            this.$message.error(window.$t('page.qualificationFile.info.subErr4'))
            return true
          }
        })
        console.log(sub)
        if(!sub) {
          this.dialogVisible1 = true
        }
      } else {
        const sub =  this.tableData.some(item => {
          if(item.id === '00' && item.fileName === '' && this.isChinese === 'zh-cn') {
            this.$message.error(window.$t('page.qualificationFile.info.subErr1'))
            return true
          }
        })
        console.log(sub)
        if(!sub) {
          this.dialogVisible1 = true
        }
      }
    },
    async confirmNext() {
      this.dialogVisible1 = false;
      let SupRegistQualFileInfoBO = this.tableData.filter(item => {
        if (item.fileName) return item;
      }).map(item => {
        return {
          billType: item.id,
          fileinfoType: item.id,
          fileName: item.fileName,
          fileSize: item.fileSize,
          fileUrl: item.fileUrl,
          fileDesc: item.fileDesc,
          fileSumm: '',
          uploadTime: item.uploadTime,
          uploadId: item.uploadId
        }
      })
      console.log(SupRegistQualFileInfoBO)
      try {
        const {data} = await saveSupplierRegistInfo({
          dataSourceFlag: 0,
          isOverseas: window.languagezh_cn?0:1,
          isShowLoading:true,
          tempSupinfoId: this.supInfoApplyId,
          // supRegistAccountInfoBO:{
          //   countyCode:sessionStorage.getItem('countyCode'),
          //   countyName:sessionStorage.getItem('countyName'),
          // },
          saveOrCommitFlag: '2',
          supRegistTab: '10',
          supRegistQualFileInfoList: SupRegistQualFileInfoBO
        })
        console.log(data)
        if(data.code === '0') {
          this.dialogVisible2 = true
        }
      } catch (err) {
        console.log(data.message)
      }
    },
    confirmSubmit() {
      this.dialogVisible2 = false
      this.isSub = true
      // window.location.href = this.$addUrlPerFix(process.env.VUE_APP_SUPPLIER_GATEWAY)
      let url='',path = window.location.href;
      if(path.indexOf("uat01") != -1){
        url='https://uat01-'+process.env.VUE_APP_SUPPLIER_GATEWAY
      }else if(path.indexOf("test01") != -1){
        url='https://test01-'+process.env.VUE_APP_SUPPLIER_GATEWAY
      }else{
        url='https://'+process.env.VUE_APP_SUPPLIER_GATEWAY
      }
      // window.location.href = 'https://'+process.env.VUE_APP_SUPPLIER_GATEWAY
      window.location.href = url
    },
    // 获取资质文件信息
    async getSupRegistQualificationFileList() {
       try {
         const {data} = await qrySupRegistQualificationFileList({
           tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
           supInfoApplyId: this.$route.query.tempSupinfoId,
           isShowLoading:true,
         })
         if(data.code === '0') {
           this.tableData.forEach(item1 => {
             data.data.supRegistQualFileInfoList.forEach(item2 => {
               if(item1.id === item2.fileinfoType) {
                 item1.fileName = item2.fileName
                 item1.fileDesc = item2.fileDesc
                 item1.fileUrl = item2.fileUrl
                 item1.fileSize = item2.fileSize
                 item1.uploadTime = item2.uploadTime
                 item1.uploadId = item2.uploadId
               }
             })
           })
          this.supInfoApplyId = data.data.supInfoApplyId
         }
       } catch (err) {
         console.log(data.message)
       }

    },
    qrySupRegistAccountInfo(){
      let params={
        tempOrFormalFlag: this.$route.query.tempOrFormalFlag?this.$route.query.tempOrFormalFlag:0,
          supInfoApplyId: this.$route.query.tempSupinfoId,
          isShowLoading:true,
      }
      qrySupRegistAccountInfo(params).then(res => {
        if (res.data.code === "0") {
          this.isCredentials=res.data.data.supRegistAccountInfoBO.isCredentials
          this.recommendIndyName=res.data.data.supRegistAccountInfoBO.recommendIndyName
          this.orgFullName=res.data.data.orgFullName
          this.supType.push(...(res.data.data.supRegistAccountInfoBO.supType || '').split(','))
        }
      });
    }
  },
}
</script>

<style scoped lang="scss">
.sign-content {
  width: 1180px;
  background: #FFFFFF;
  margin: 20px auto;
  overflow: hidden;
  position: relative;
  .el-card-title {
    /deep/ .details-title {
      top: 20px;
      color: black;
      border-bottom: 0px;
    }
  }
  .danger-title {
    position: absolute;
    left:145px;
    top:22px;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #4A4A4A;
    line-height: 18px;
    font-weight: 400;
    .span-num {
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #D5090B;
      line-height: 18px;
      font-weight: 400;
    }
  }
  .danger-title-en {
    position: absolute;
    left:448px;
    top:22px;
    font-family: PingFangSC-Regular;
    font-size: 13px;
    color: #4A4A4A;
    line-height: 18px;
    font-weight: 400;
    .span-num {
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #D5090B;
      line-height: 18px;
      font-weight: 400;
    }
  }
  /deep/ .el-input .el-input__inner {
    width: 308px;
    padding: 0px 46px 0px 8px;
  }
  /deep/ .el-table__row .el-table_3_column_14 .cell {
    position: relative;
  }
  /deep/ .el-table__row .el-table_2_column_11 .upload-demo {
    width: 66px;
    .el-upload .el-button span {
      color: #ff142f;
    }
  }
  /deep/ .el-table__row .cell .removeBtn {
    position: absolute;
    left: 66px;
    top: 0px;
    span {
      color: #ff142f;
    }
  }
}
.btn {
  width: 240px;
  height: 40px;
  background: #FF142F;
  margin-bottom: 20px;
  span {
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFangSC;
    font-weight: 600;
  }
}
.btnBox {
  margin: 0px auto;
  width: 500px;
}
/deep/.cell{
  word-break: break-all!important;
  width:97%!important;
}
/deep/ .el-table--border {
  th:last-of-type.gutter {
    display: table-cell !important;
    width: 0px !important;
  }
}
</style>
